import { render, staticRenderFns } from "./goodsIn.vue?vue&type=template&id=ae0a784c&scoped=true&"
import script from "./goodsIn.vue?vue&type=script&lang=js&"
export * from "./goodsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0a784c",
  null
  
)

export default component.exports